export default __webpack_public_path__ + "static/media/blank-image.a9136072.png";